import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Carousel, CarouselVariant } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { LazyLoadOptions } from '@as-react/common-types';
import { Breakpoint, ButtonLink, Divider, StackBlock, TextAlpha } from '@yonderland/andes-react';
import { Fragment, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { SLIDE_SPACING } from '../../../constants/SliderConstants';
import { useProductDetailContext } from '../../../containers/product/ProductDetailV2Container';
import compareActions from '../../../redux/compare/actions/CompareActions.creators';
import { makeGetCompareItems } from '../../../redux/compare/selectors/CompareSelectors';
import { productActions } from '../../../redux/product/actions/ProductActions';
import { makeGetAlternativeProducts, makeGetProductCategory } from '../../../redux/product/selectors/ProductSelector';
import { wishListActions } from '../../../redux/wishList/actions/WishListActions.creators';
import { AlternativeProductTileAlpha } from '../../product-tile/alternative/AlternativeProductTileAlpha';
import { ProductTileVertical } from '../../product-tile/vertical/ProductTileVertical';
const MAX_PRODUCTS_AMOUNT_MOBILE = 6;
const MAX_PRODUCTS_AMOUNT_TABLET = 3;
export const ProductAlternativesAlpha = () => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { alternatives } = useProductDetailContext();
    const { root, feature_toggles: { lowest_price_all }, } = useAemConfig();
    const alternativeProducts = useSelector(makeGetAlternativeProducts());
    const category = useSelector(makeGetProductCategory());
    const compareItems = useSelector(makeGetCompareItems());
    const dispatch = useDispatch();
    const updateCompareList = (compareProduct) => dispatch(compareActions.createUpdateOnProductDetailPageAction(compareProduct));
    const onWishListToggle = (wishListProduct) => dispatch(wishListActions.toggleProduct(wishListProduct));
    const carouselConfig = {
        variant: CarouselVariant.PRODUCT_TILE_NORMAL,
        showPagination: false,
        fullWidth: true,
        configurationOverrides: {
            preventClicks: true,
            slidesPerView: 'auto',
            spaceBetween: SLIDE_SPACING.MOBILE,
            watchOverflow: true,
            shouldSwiperUpdate: true,
        },
    };
    useEffect(() => {
        if (alternativeProducts === undefined && ((alternatives === null || alternatives === void 0 ? void 0 : alternatives.campaign) || (alternatives === null || alternatives === void 0 ? void 0 : alternatives.campaignFallback))) {
            dispatch(productActions.fetchAlternatives(alternatives));
        }
    }, []);
    if (!(alternativeProducts === null || alternativeProducts === void 0 ? void 0 : alternativeProducts.length)) {
        return null;
    }
    return (_jsxs(StackBlock, { gap: "4", testId: "product-alternatives", children: [_jsx(TextAlpha, { variant: "headingS", as: "h2", children: t('pdp.alternatives.title') }), _jsx(Breakpoint, { until: "md", children: _jsx(Carousel, Object.assign({}, carouselConfig, { children: alternativeProducts.slice(0, MAX_PRODUCTS_AMOUNT_MOBILE).map(product => (_jsx("div", { children: _jsx(ProductTileVertical, { product: product, onWishListToggle: onWishListToggle, updateCompareList: updateCompareList, shouldLazyLoadImage: LazyLoadOptions.LAZY_LOAD, compareItems: compareItems, parentId: "product-alternatives", enablePriceReference: lowest_price_all }) }, `${product.productCode}${product.colourId}`))) })) }), _jsx(Breakpoint, { from: "md", children: alternativeProducts.slice(0, MAX_PRODUCTS_AMOUNT_TABLET).map((product, index, products) => (_jsxs(Fragment, { children: [_jsx(AlternativeProductTileAlpha, { product: product, onWishListToggle: onWishListToggle, updateCompareList: updateCompareList }), index !== products.length - 1 && _jsx(Divider, {})] }, `${product.productCode}${product.colourId}`))) }), category && (_jsx(ButtonLink, { theme: "branded", variant: "secondary", href: `${root}c${category.relativeUrl}.html`, children: t('pdp.alternatives.show.all.results') }))] }));
};
